import React from "react";
import {ChipLabel} from "./index";

const DraftStatusChip = ({status}) => {
    const statusData = {
        "approved": {
            class: "status-chip success",
            text: "Live"
        },
        "hidden": {
            class: "status-chip error",
            text: "Hidden"
        },
        "rejected": {
            class: "status-chip error",
            text: "Rejected"
        },
        "pending": {
            class: "status-chip warning",
            text: "Pending"
        },
        "raw": {
            class: "status-chip error",
            text: "Not Activated"
        },
        "raw_inactive": {
            class: "status-chip secondary",
            text: "Inactive"
        },
        "inactive": {
            class: "status-chip error",
            text: "Inactive"
        },
        "draft": {
            class: "status-chip warning",
            text: "Draft"
        },
        "published": {
            class: "status-chip success",
            text: "Published"
        },
    }

    return (<ChipLabel label={statusData[status]?.text} className={statusData[status]?.class}/>)
}

export default DraftStatusChip;